import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AdminLog } from '../models/admin-usuario';
import { AbstractService } from './abstract.service';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class AdminLogService extends AbstractService<AdminLog> {

  titulo: string = 'Log de Operações';
  endpoint(): string {
    return "log-operacoes";
  }
  rotina(): string {
    return "ADMIN_LOG";
  }
  colunas(): any[] {
    return [
      { header: "Código", field: "id" },
      { header: "Nome", field: "descricao" },
    ];
  }
  novo(selection?: any) {
    AbstractService.readonly = false;
    this.router.navigate(['admin/log']);
  }
  abrir(obj: AdminLog) {
    AbstractService.readonly = true;
    this.router.navigate(['admin/log'], { queryParams: { id: obj.id } });
  }
  edit(obj: AdminLog) {
    AbstractService.readonly = false;
    this.router.navigate(['admin/log'], { queryParams: { id: obj.id } });
  }
  routeLista() {
    return 'admin/log';
  }

  constructor(
    http: HttpClient,
    private router: Router,
    loginService: LoginService
  ) {
    super(http, loginService);
  }
}
